import each from 'lodash/each'

import BaseFormCollection from 'modules/reports/lib/Store/FormCollections/Base'
import type { ConditionParams } from 'modules/reports/store/models/Condition'
import type Field from 'modules/reports/store/models/Field'
import type { FilterParams } from 'modules/reports/store/models/Filter'

import ConditionForm from './ConditionForm'

interface Props {
  filter?: FilterParams
}

class ConditionFormCollection<T extends ConditionForm> extends BaseFormCollection<T> {
  FormClass: any

  constructor(props: Props) {
    super()
    this.FormClass = ConditionForm

    const { filter } = props
    this.forms = filter ? (ConditionForm.buildForms(filter) as any) : []
  }

  convertToParams(): ConditionParams[] | null | undefined {
    return ConditionForm.convertToParams(this.forms)
  }

  addFiltersFields(fields: Field[]) {
    each(fields, (field: Field) => {
      const index = this.forms.length

      const values = {
        path: field.attributes.path,
      }
      this.forms[index] = new this.FormClass(values)
    })
  }
}

export default ConditionFormCollection
